module.exports = __webpack_public_path__ + "img/consultoria_16-9_1440.59765bcc.jpg";